<script lang="ts">
  import Icon from "@shared/svelte/Components/Icon.svelte";
  import { default as RetailerUserAuthenticationsStore } from "@retailer/svelte/stores/RetailerUserAuthenticationsStore";
  import { getStockSiteLocation } from "@shared/services/retailer_user_authentication_service";

  export let distributorId: number = null;

  let auth;
  $: auth = $RetailerUserAuthenticationsStore?.find(a => a.distributor_id == distributorId);
</script>

<div class="flex flex-column items-center">
  <div class="fizz-stack-32">
    <Icon type="Enroll" width={200} height={200} />
  </div>
  <h2 class="flex-1 text-center fizz-stack-16"> You're Connected </h2>
</div>
<p class="fizz-text-subdued fizz-inset-horizontal-16 fizz-stack-32 fizz-text-large text-center">
  You can now access and order high proof spirits & liquor from your agency store:
</p>
{#await getStockSiteLocation(distributorId, auth?.account_number) then data}
  <div class="fizz-stack-32">
    <h4 class="text-center fizz-stack-8 fizz-heading-4">
      <p>{data.name || ""}</p>
    </h4>
    <p class="text-center fizz-text-subdued"
      >{data.address} {data.city} {data.region} {data.postalCode}</p
    >
  </div>
{/await}
